export const createTooltip = function(text) {
    const $tooltip = document.createElement('div');
    const $tooltipArrow = document.createElement('div');
    $tooltip.classList.add('tooltip')
    $tooltipArrow.classList.add('tooltip-arrow')
    $tooltip.append($tooltipArrow)
    $tooltip.insertAdjacentText('beforeend', text)

    return {$tooltip, $tooltipArrow};
}